import { render, staticRenderFns } from "./ConnectionStats.vue?vue&type=template&id=aa1a07b0&scoped=true"
import script from "./ConnectionStats.vue?vue&type=script&lang=js"
export * from "./ConnectionStats.vue?vue&type=script&lang=js"
import style0 from "./ConnectionStats.vue?vue&type=style&index=0&id=aa1a07b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1a07b0",
  null
  
)

export default component.exports